<!-- =========================
     DIAGONAL SPLIT (same structure as the landing page hero / login)
========================= -->
<section class="min-vh-100 overflow-hidden position-relative bcx-diagonal-hero bcx-diagonal-hero-auth">
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-black"></div>
  <div class="position-absolute top-0 start-0 w-100 h-100 bcx-diagonal-white"></div>

  <div v-if="error_message || success_message" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
    <div v-if="error_message" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
      <div class="d-flex align-items-center gap-3 p-3">
        <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
          <i class="bi bi-exclamation-circle"></i>
        </span>
        <div class="toast-body p-0 fw-semibold lh-sm">{{ error_message }}</div>
        <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_error_message"></button>
      </div>
    </div>

    <div v-if="success_message" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-success" role="status">
      <div class="d-flex align-items-center gap-3 p-3">
        <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
          <i class="bi bi-check2-circle"></i>
        </span>
        <div class="toast-body p-0 fw-semibold lh-sm">{{ success_message }}</div>
        <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss success message" @click="clear_success_message"></button>
      </div>
    </div>
  </div>

  <!-- =========================
       CONTENT — left (white) / right (black), same as hero/login
  ========================== -->
  <div class="container-fluid px-3 px-md-4 px-lg-5 position-relative z-3 min-vh-100 d-flex align-items-center bcx-diagonal-copy">
    <div class="row align-items-center w-100 gy-4">

      <!-- LEFT / WHITE SIDE — branding -->
      <div class="col-12 col-lg-3">
        <router-link to="/" class="auth-logo d-inline-block mb-4" aria-label="BCX Home"></router-link>
        <h1 class="fw-bold display-5 mb-0 bcx-diagonal-line-dark">
          ONE MORE STEP.
        </h1>
      </div>

      <!-- RIGHT / BLACK SIDE — OTP form -->
      <div class="col-12 col-lg-6 offset-lg-3">

        <p class="text-white text-opacity-75 mb-4">
          We've sent a 6-digit security code to <strong class="text-white">{{ email }}</strong>.
        </p>

        <!-- LOADING STATE -->
        <div v-if="is_loading" class="mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-white text-opacity-75">Verifying code...</span>
        </div>

        <!-- OTP FORM -->
        <form v-if="!is_loading" @submit.prevent="submit_otp" style="max-width: 26rem;">

          <!-- OTP INPUTS -->
          <div class="d-flex justify-content-between mb-4 otp-inputs">
            <input
              v-for="(digit,index) in otp"
              :key="index"
              maxlength="1"
              v-model="otp[index]"
              @input="handle_input(index,$event)"
              @paste="handle_paste(index,$event)"
              @keydown.backspace="handle_backspace(index,$event)"
              inputmode="numeric"
              autocomplete="one-time-code"
              placeholder="0"
              class="form-control text-center otp-input-box"
            />
          </div>

          <!-- Resend -->
          <p class="text-white text-opacity-75 text-xs mb-2">
            Didn't receive the code?
            <span class="text-danger fw-semibold cursor-pointer" @click="resend_otp">
              Resend OTP
            </span>
          </p>

          <!-- Timer -->
          <p class="text-white text-opacity-75 text-xs mb-0">
            You can resend in <strong class="text-white">{{ formatted_timer }}</strong>
          </p>

          <!-- Back -->
          <p class="mt-3 mb-0 text-xs">
            <router-link to="/login" class="text-decoration-none text-white text-opacity-75">
              ← Back to login
            </router-link>
          </p>

        </form>

      </div>

    </div>
  </div>
</section>
